/** Define how letter mailings are priced */
const letterPricing = {
	base: 0.95,
	perPage: 0.15,
	additionalPerPageInColor: 0.1,
	minimum: 1.15,
};

export default letterPricing;
